import React, { useState, useRef, useEffect } from 'react';

function ThemeSwitcher({ currentTheme, onThemeChange }) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    
    const themes = [
        { id: 'default', name: 'Default Purple' },
        { id: 'modern-blue', name: 'Modern Blue' },
        { id: 'forest', name: 'Forest' },
        { id: 'crimson', name: 'Crimson' },
        { id: 'cyber-teal', name: 'Cyber Teal' },
        { id: 'sunset-orange', name: 'Sunset Orange' },
        { id: 'midnight-violet', name: 'Midnight Violet' },
        { id: 'arctic-blue', name: 'Arctic Blue' }
    ];
    
    // Close dropdown when clicking outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    
    // Get current theme object
    const currentThemeObj = themes.find(theme => theme.id === currentTheme) || themes[0];
    
    return (
        <div className="theme-switcher-container" ref={dropdownRef}>
            <button 
                type="button"
                className="theme-toggle-button" 
                onClick={() => setIsOpen(!isOpen)}
                aria-label="Toggle theme options"
                aria-expanded={isOpen}
                data-theme={currentTheme}
            >
                <span className="material-symbols-outlined">palette</span>
            </button>
            
            {isOpen && (
                <div className="theme-dropdown">
                    <div className="theme-dropdown-header">
                        <span>Select Theme</span>
                    </div>
                    <div className="theme-options">
                        {themes.map(theme => (
                            <button
                                type="button"
                                key={theme.id}
                                className={`theme-option ${currentTheme === theme.id ? 'active' : ''}`}
                                onClick={() => {
                                    onThemeChange(theme.id);
                                    setIsOpen(false);
                                }}
                                aria-label={`Switch to ${theme.name} theme`}
                                aria-pressed={currentTheme === theme.id}
                            >
                                <span 
                                    className="theme-color-preview" 
                                    data-theme={theme.id}
                                ></span>
                                <span className="theme-name">{theme.name}</span>
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

export default ThemeSwitcher; 